/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Alpha_WarningInputs */

const en_highlight_settings_alpha_warning = /** @type {(inputs: Highlight_Settings_Alpha_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is alpha version, some options may not work as expected`)
};

const es_highlight_settings_alpha_warning = /** @type {(inputs: Highlight_Settings_Alpha_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versión alfa: algunas opciones podrían no funcionar bien`)
};

/**
* | output |
* | --- |
* | "This is alpha version, some options may not work as expected" |
*
* @param {Highlight_Settings_Alpha_WarningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_alpha_warning = /** @type {((inputs?: Highlight_Settings_Alpha_WarningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Alpha_WarningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_alpha_warning(inputs)
	return en_highlight_settings_alpha_warning(inputs)
});